import React from "react";

const NoUsers = () => (
    <div className="flex items-center justify-center py-6 text-gray-500 text-sm italic space-x-2">
      <svg
        className="w-5 h-5 text-gray-400"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 4v16m8-8H4"
        />
      </svg>
      <span>No Available Users</span>
    </div>
  );
  
  export default NoUsers;
  